"use client";

import { useState } from "react";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { portalAuthApi } from "@/lib/api/portal-auth";
import { useTranslation } from "@/lib/i18n";

/** One secondary action shared by the dashboard and the narrower portal pages. */
export function PortalSignOutButton() {
  const { t } = useTranslation();
  const [pending, setPending] = useState(false);
  async function signOut() {
    setPending(true);
    try {
      await portalAuthApi.logout();
    } finally {
      window.location.href = "/portal/login";
    }
  }
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      data-testid="portal-sign-out"
      disabled={pending}
      onClick={() => void signOut()}
    >
      <LogOut aria-hidden="true" />
      {pending ? t("portal.shell.signingOut") : t("portal.shell.signOut")}
    </Button>
  );
}
